import { c as _c } from "react/compiler-runtime";
import type { Spec } from '@json-render/core';
import { JSONUIProvider, Renderer } from '@json-render/react';
import { ErrorBoundary } from 'react-error-boundary';
import { parseAndMigrateSpec } from './parser-utils';
import { registry } from './registry';
type GenUiBlockRendererProps = {
  content: string;
  hideRootTitle?: boolean;
  schemaVersion?: number;
};

/** Components where the title/name duplicates the block header and should be stripped. */
const STRIP_TITLE_COMPONENTS = new Set(['FindingsCard', 'KVList', 'DataTable', 'Timeline', 'TagList', 'StructuringChart', 'ScreeningResults', 'NetworkGraph', 'StatRow']);
const STRIP_NAME_COMPONENTS = new Set(['InvestigationSummary']);
const stripRootTitle = (spec: Spec): Spec => {
  const rootEl = spec.elements[spec.root] as {
    type: string;
    props?: Record<string, unknown>;
    children: string[];
  };
  if (!rootEl?.props) return spec;
  let newProps = rootEl.props;
  if (STRIP_TITLE_COMPONENTS.has(rootEl.type)) {
    const {
      title: _title,
      ...rest
    } = newProps;
    newProps = {
      ...rest,
      title: ''
    };
  } else if (STRIP_NAME_COMPONENTS.has(rootEl.type)) {
    const {
      name: _name,
      ...rest
    } = newProps;
    newProps = rest;
  } else {
    return spec;
  }
  return {
    ...spec,
    elements: {
      ...spec.elements,
      [spec.root]: {
        ...rootEl,
        props: newProps
      }
    }
  } as Spec;
};
export const GenUiBlockRenderer = t0 => {
  const $ = _c(7);
  const {
    content,
    hideRootTitle,
    schemaVersion
  } = t0;
  let spec;
  let t1;
  if ($[0] !== content || $[1] !== hideRootTitle || $[2] !== schemaVersion) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      spec = parseAndMigrateSpec(content, schemaVersion);
      if (!spec) {
        t1 = null;
        break bb0;
      }
      if (hideRootTitle) {
        spec = stripRootTitle(spec);
      }
    }
    $[0] = content;
    $[1] = hideRootTitle;
    $[2] = schemaVersion;
    $[3] = spec;
    $[4] = t1;
  } else {
    spec = $[3];
    t1 = $[4];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  let t2;
  if ($[5] !== spec) {
    t2 = <ErrorBoundary fallback={null} onError={_temp}><div className="h-full w-full p-4 md:p-5 flex flex-col gap-8 [&>*:empty]:hidden [&>*:has([role=alert])+*:has([role=alert])]:!-mt-5"><JSONUIProvider registry={registry}><Renderer spec={spec} registry={registry} /></JSONUIProvider></div></ErrorBoundary>;
    $[5] = spec;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp(err) {
  return console.error("[GenUiBlockRenderer] render error:", err);
}